(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["extralife-hero-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    function initHeroCarousel(root) {
      var track = root.querySelector('[data-elhc-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-elhc-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-elhc-dot]'));
      var prevBtn = root.querySelector('[data-elhc-prev]');
      var nextBtn = root.querySelector('[data-elhc-next]');
      if (slides.length < 2) return;

      var index = 0;

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (slide, n) {
          var active = n === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (slide.tagName === 'A') {
            if (active) { slide.removeAttribute('tabindex'); }
            else { slide.setAttribute('tabindex', '-1'); }
          }
        });
        dots.forEach(function (dot, n) {
          var active = n === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); });
      dots.forEach(function (dot, n) {
        dot.addEventListener('click', function () { show(n); });
      });

      /* свайп на дотик — тільки горизонтальний, без заважання вертикальному скролу */
      var touchStartX = null;
      var touchStartY = null;
      track.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          show(dx < 0 ? index + 1 : index - 1);
        }
        touchStartX = null;
        touchStartY = null;
      }, { passive: true });

      /* ── автоперемикання слайдів (пауза при наведенні, фокусі, у фоні) ── */
      var elhcAutoMs = 5000;
      var elhcTimer = null;
      function elhcStart() {
        elhcStop();
        elhcTimer = window.setInterval(function () { show(index + 1); }, elhcAutoMs);
      }
      function elhcStop() {
        if (elhcTimer) { window.clearInterval(elhcTimer); elhcTimer = null; }
      }
      if (prevBtn) prevBtn.addEventListener('click', elhcStart);
      if (nextBtn) nextBtn.addEventListener('click', elhcStart);
      dots.forEach(function (dot) { dot.addEventListener('click', elhcStart); });
      root.addEventListener('mouseenter', elhcStop);
      root.addEventListener('mouseleave', elhcStart);
      root.addEventListener('focusin', elhcStop);
      root.addEventListener('focusout', elhcStart);
      track.addEventListener('touchstart', elhcStop, { passive: true });
      track.addEventListener('touchend', elhcStart, { passive: true });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { elhcStop(); } else { elhcStart(); }
      });
      elhcStart();
    }

    document.querySelectorAll('[data-elhc]').forEach(initHeroCarousel);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["extralife-promo"] && !Shopify.designMode) return;
  try {
    class ExtraLifePromo extends HTMLElement {
    connectedCallback() {
      this.code = this.dataset.code;
      this.KEY = 'el_promo_v1';
      this.bar = this.querySelector('[data-elp-bar]');
      this.promoSlide = this.querySelector('[data-elp-open]');
      this.modal = this.querySelector('[data-elp-modal]');

      // Стан: 'claimed' — код уже отримано.
      let st = {};
      try { st = JSON.parse(localStorage.getItem(this.KEY)) || {}; } catch (e) { st = {}; }
      this.state = st;

      // Смуга — тільки про знижку. Отримав код — смуга більше не потрібна.
      // ExtraLife 2026-09-25: на головній смугу не показуємо (правка клієнта, п.6).
      if (!this.state.claimed && !this.hasAttribute('data-no-bar')) {
        this.bar.hidden = false;
        this.bar.setAttribute('data-visible', '');
      }

      this.promoSlide.addEventListener('click', () => this.open());
      this.querySelector('[data-elp-close]').addEventListener('click', () => this.close());
      this.modal.addEventListener('click', (e) => { if (e.target === this.modal) this.close(); });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !this.modal.hidden) this.close();
      });
      this.querySelector('form.elp-form').addEventListener('submit', (e) => this.submit(e));
      this.querySelector('[data-elp-copy]').addEventListener('click', () => this.copy());

      // Код уже є → тихо тримаємо його застосованим у кошику.
      if (this.state.claimed) this.applyToCart();

      // Повернення після успішної підписки (Shopify додає ?customer_posted=true)
      // → одразу показуємо код, щоб людина не шукала його вручну.
      if (new URLSearchParams(location.search).get('customer_posted') === 'true' && this.state.claimed) {
        this.showDone();
        this.open();
        // Прибираємо параметр, щоб попап не вискакував при кожному оновленні.
        const u = new URL(location.href);
        u.searchParams.delete('customer_posted');
        history.replaceState({}, '', u);
      }
    }

    open() {
      // Якщо код уже отримано — одразу показуємо його, без форми.
      if (this.state.claimed) this.showDone();
      this.modal.hidden = false;
      document.body.style.overflow = 'hidden';
      const focusTarget = this.state.claimed
        ? this.querySelector('[data-elp-copy]')
        : this.querySelector('#elp-email');
      if (focusTarget) focusTarget.focus();
    }

    close() {
      this.modal.hidden = true;
      document.body.style.overflow = '';
    }

    showDone() {
      this.querySelector('[data-elp-step="form"]').hidden = true;
      this.querySelector('[data-elp-step="done"]').hidden = false;
    }

    // Форма йде звичайним POST (інакше Shopify відповідає 400 «Missing CAPTCHA
    // token»). Ми лише валідуємо адресу і запам'ятовуємо намір — після
    // перезавантаження Shopify повертає ?customer_posted=true, і ми показуємо код.
    submit(e) {
      const input = this.querySelector('#elp-email');
      const err = this.querySelector('[data-elp-err]');
      const email = (input.value || '').trim();

      if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)) {
        e.preventDefault();
        err.hidden = false;
        input.focus();
        return;
      }
      err.hidden = true;
      // Позначаємо намір ДО переходу — сторінка зараз перезавантажиться.
      try {
        localStorage.setItem(this.KEY, JSON.stringify({ claimed: true, email: email, at: Date.now() }));
      } catch (_) {}
      this.querySelector('[data-elp-submit]').textContent = 'Хвилинку…';
      // e.preventDefault() НЕ викликаємо — хай браузер відправить форму сам.
    }

    // Shopify запам'ятовує код у сесії через /discount/<CODE>.
    // Тягнемо його прихованим запитом, щоб не смикати користувача з сторінки.
    applyToCart() {
      fetch('/discount/' + encodeURIComponent(this.code), { method: 'GET', credentials: 'same-origin' })
        .catch(() => {});
    }

    async copy() {
      const hint = this.querySelector('[data-elp-copy-hint]');
      try {
        await navigator.clipboard.writeText(this.code);
        hint.textContent = 'скопійовано ✓';
      } catch (_) {
        const r = document.createRange();
        r.selectNodeContents(this.querySelector('[data-elp-code-text]'));
        const sel = getSelection();
        sel.removeAllRanges();
        sel.addRange(r);
        hint.textContent = 'виділено';
      }
      setTimeout(() => { hint.textContent = 'копіювати'; }, 2000);
    }
  }

  if (!customElements.get('extralife-promo')) {
    customElements.define('extralife-promo', ExtraLifePromo);
  }
  } catch(e) { console.error(e); }
})();

})();
